export const GET_CHECKIN =
  'pages/coach/userManagement/singleUser/stakeholderEngagement/monthlyCheckIns/getCheckin'

export const questionOne =
  'How did I do over the last 30 days on my leadership goals?'
export const questionTwo =
  'What suggestions do you have for me in the next 30 days?'
